import React from 'react'

import { ReactComponent as Location } from 'assets/icons/location.svg'

const Address: React.FC = () => {
  return (
    <div className="row address-location margin-top-16">
      <div className="list">
        <div className="list-header">
          <div className="">Nome</div>
          <div className="">CEP</div>
          <div className="">Rua</div>
          <div className="">Nº</div>
          <div className="">Setor / Complemento</div>
          <div className="">Cidade / Estado</div>

        </div>
        <div className="list-row">

          <div className="">Casa</div>
          <div className="">76100-000</div>
          <div className="">Rua São Domingos</div>
          <div className="">001</div>
          <div className="">São josé, Próximo ao Comércio</div>
          <div className="">São Luís de Montes Belos - GO</div>

          <span
            className=""
            style={{
              height: 40,
              width: 40,
              backgroundColor: '#00000012',
              borderRadius: '50%',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <Location height="20" width="35" /></span>
        </div>
      </div>
    </div>
  )
}

export default Address
